import {Injectable} from '@angular/core';
import {Order, Sort} from '../../../../../../shared/utils/url.builder';
import {User} from '../entity/user.model';
import {
    AbstractFindManyPaginatedService
} from '../../../../../core/service/v2/service/findmany/abstractFindManyPaginated.service';
import {UserRepository} from '../../impl/service/ngrx/user.repository';
import {UserSummary} from '../entity/userSummary.model';
import {UserSummaryDataServiceAdapter} from '../../impl/service/ngrx/userSummaryDataService.adapter';

@Injectable()
export class UserSummaryPaginatedService extends AbstractFindManyPaginatedService<User, UserSummary> {

    constructor(repository: UserRepository, dataServiceAdapter: UserSummaryDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
